<template>
  <div class="contactus">
    <sub-header />

    <article class="sub-body res_wrap px-3 mt-16 pt-0 pt-md-16">
      <section class="sub-body-title">
        <h3 class="text-h4 text-sm-h2 font-weight-bold">{{$route.meta.pageTitle}}</h3>
      </section>
      <section class="sub-body-content">

        <v-container fluid>
            <!-- <v-card width="100%" class="mt-2 px-4 py-14" outlined>
              <v-row class="align-stretch justify-center" no-gutters>
                <v-col cols="12" sm="8" lg="6">

                  <v-text-field name="name" label="Your Name (required)" placeholder="Enter your name" outlined></v-text-field>
                  <v-text-field name="email" label="E-mail address (required)" placeholder="Enter your email address" outlined></v-text-field>
                  <v-textarea name="message" label="Message" placeholder="Enter your message" outlined></v-textarea>

                </v-col>
                <v-col cols="12" class="text-center">
                  <v-btn depressed x-large dark type="submit">
                    Send Message
                  </v-btn>
                </v-col>
              </v-row>
            </v-card> -->

            <!-- <v-row class="align-stretch justify-center contact-info mt-16" no-gutters>
                <v-col cols="12" sm="8" lg="6">
                  <router-link :to="{name:'Home'}" exact><img src="@/assets/logo_header_l.svg" /></router-link>
                  <ul class="mt-4">
                    <li>
                      <v-dialog v-model="dialog" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on" ><v-icon small class="pr-2 ml-1">mdi-map-marker</v-icon> <strong>본사 : </strong> (16942) 경기도 용인시 수지구 광교중앙로 338 (상현동, 광교우미뉴브 B동 310호)</div>
                        </template>
                        <v-card class="pa-2 pb-1">
                          <iframe width="100%" height="450" frameborder="0" style="border:0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1586.8917150185328!2d127.06938145815477!3d37.300266294962206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b5b00b6c8fa2b%3A0xaf803d7d29f0f8f1!2z6rSR6rWQ7Jqw66-464m067iMIChBLEIsQ-uPmSk!5e0!3m2!1sko!2skr!4v1581568361739!5m2!1sko!2skr" allowfullscreen=""></iframe>
                        </v-card>
                      </v-dialog>
                    </li>
                    <li>
                      <v-dialog v-model="dialog2" width="500">
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on" ><v-icon small class="pr-2 ml-1">mdi-map-marker</v-icon> <strong>지사 : </strong> (07299) 서울특별시 영등포구 경인로 775 에이스하이테크시티(문래동3가, 1동 707-1호)</div>
                        </template>
                        <v-card class="pa-2 pb-1">
                          <iframe width="100%" height="450" frameborder="0" style="border:0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.7230805809663!2d126.89658471564707!3d37.51444893486646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9ff70961aa95%3A0xae4024d663472891!2z7JeQ7J207Iqk7ZWY7J207YWM7YGs7Iuc7Yuw!5e0!3m2!1sko!2skr!4v1617349205843!5m2!1sko!2skr" allowfullscreen=""></iframe>
                        </v-card>
                      </v-dialog>
                    </li>
                    <li><a href="mailto:jeinsoft@jeinsoft.co.kr"><v-icon small class="pr-2 ml-1">mdi-email</v-icon> jeinsoft@jeinsoft.co.kr</a></li>
                    <li><a href="tel:031-719-7805"><v-icon small class="pr-2 ml-1">mdi-phone</v-icon> (031) 719-7805</a></li>
                    <li><a href="mailto:cyjeong@jeinsoft.co.kr"><v-icon small class="pr-2 ml-1">mdi-email</v-icon> cyjeong@jeinsoft.co.kr (영업대표 정창열부장)</a></li>
                    <li><a href="tel:010-7149-3432"><v-icon small class="pr-2 ml-1">mdi-phone</v-icon> 010-7149-3432 (영업대표 정창열부장)</a></li>
                  </ul>
                </v-col>

              </v-row> -->

            <v-card width="100%" class="mt-2 px-4 py-12" outlined>
              <v-row class="align-stretch justify-center contact-info" no-gutters>
                <v-col cols="12" sm="9" lg="7">
                  <router-link :to="{name:'Home'}" exact>
                    <v-img src="@/assets/logo_header_l.svg" max-height="2rem" contain></v-img>
                  </router-link>
                  <ul class="mt-10 text-subtitle-1">
                    <li>
                      <v-icon small class="pr-2 ml-1">mdi-map-marker</v-icon>
                      <strong>본사 : </strong> (16942) 경기도 용인시 수지구 광교중앙로 338 (상현동, 광교우미뉴브 B동 310호)
                    </li>
<!--                    <li>-->
<!--                      <v-icon small class="pr-2 ml-1">mdi-map-marker</v-icon>-->
<!--                      <strong>지사 : </strong> (06729) 서울 서초구 효령로 424 대명빌딩 301호-->
<!--                    </li>-->
                  </ul>

                  <v-row class="mt-4">
                    <v-col cols="12" sm="6">
                      <ul class="text-subtitle-1">
                        <li class="font-weight-bold">제인소프트 연락처</li>
                        <li><v-icon small class="pr-2 ml-1">mdi-email</v-icon><a href="mailto:jeinsoft@jeinsoft.co.kr">jeinsoft@jeinsoft.co.kr</a></li>
                        <li><v-icon small class="pr-2 ml-1">mdi-phone</v-icon><a href="tel:031-719-7805"> (031) 719-7805</a></li>
                      </ul>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <ul class="text-subtitle-1">
                        <li class="font-weight-bold">영업대표 박상현전무</li>
                        <li><v-icon small class="pr-2 ml-1">mdi-email</v-icon><a href="mailto:cyjeong@jeinsoft.co.kr"> shpak@jeinsoft.co.kr</a></li>
                        <li><v-icon small class="pr-2 ml-1">mdi-phone</v-icon><a href="tel:010-6652-9026"> 010-6652-9026</a></li>
                      </ul>
                    </v-col>
                  </v-row>
                </v-col>

              </v-row>
            </v-card>

        </v-container>


    <!-- <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" >
          <strong>본사 : </strong> (16942) 경기도 용인시 수지구 광교중앙로 338 (상현동, 광교우미뉴브 B동 310호)
        </div>
      </template>
      <v-card class="pa-2">
        <iframe width="100%" height="450" frameborder="0" style="border:0" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1586.8917150185328!2d127.06938145815477!3d37.300266294962206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b5b00b6c8fa2b%3A0xaf803d7d29f0f8f1!2z6rSR6rWQ7Jqw66-464m067iMIChBLEIsQ-uPmSk!5e0!3m2!1sko!2skr!4v1581568361739!5m2!1sko!2skr" allowfullscreen=""></iframe>
      </v-card>
    </v-dialog> -->


      </section>
    </article>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'contactus',
  data() {
    return {
      dialog: false,
      dialog2: false,
    };
  },

  created () {
  },

  mounted: function(){
    gsap.from(".sub-body-title", {
      scrollTrigger: {
        trigger: ".sub-body-title",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3,
    });
    gsap.from(".sub-body-content", {
      scrollTrigger: {
        trigger: ".sub-body-content",
        toggleActions: "restart none none none",
      },
      duration: .6, y: -50, opacity: 0, stagger: .3, delay: .3
    });

    new daum.roughmap.Lander({
      "timestamp" : "1643245416568",
      "key" : "28xsb",
      "mapWidth" : "100%",
      "mapHeight" : "450"
    }).render();

    new daum.roughmap.Lander({
      "timestamp" : "1643245327713",
      "key" : "28xsa",
      "mapWidth" : "100%",
      "mapHeight" : "450"
    }).render();
  },

  methods: {
  }

};
</script>

<style scoped>
</style>
